import {
  IPlatformCriterion,
  IPlatformCriterionPayload,
  IPlatformResourceResponse,
  IPlatformResourcesResponse
} from 'types/platformResources';
import request from './index';

export const getPlatformCriteria = () =>
  request<IPlatformResourcesResponse<IPlatformCriterion>>({
    options: { url: '/platform/resources/criteria', method: 'get' }
  });

export const createPlatformCriterion = (data: IPlatformCriterionPayload) =>
  request<IPlatformResourceResponse<IPlatformCriterion>>({
    options: { url: '/platform/resources/criteria', method: 'post', data }
  });

export const editPlatformCriterion = (id: number, data: IPlatformCriterionPayload) =>
  request<IPlatformResourceResponse<IPlatformCriterion>>({
    options: { url: `/platform/resources/criteria/${id}`, method: 'patch', data }
  });

export const deletePlatformCriterion = (id: number) =>
  request<Record<string, never>>({
    options: { url: `/platform/resources/criteria/${id}`, method: 'delete' }
  });
